/**
 * AMADEUS Archive – Theme JavaScript
 */

(function() {
  'use strict';

  /* ---- Sticky Header Shadow ---- */
  const header = document.querySelector('.site-header');
  if (header) {
    let lastScroll = 0;
    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset;
      if (currentScroll > 10) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
      lastScroll = currentScroll;
    }, { passive: true });
  }

  /* ---- Mobile Drawer (same slide-over pattern as the cart drawer) ---- */
  const hamburger = document.querySelector('.hamburger');
  const drawer = document.querySelector('.mobile-drawer');
  const drawerOverlay = document.querySelector('.mobile-drawer-overlay');
  const drawerClose = document.querySelector('.mobile-drawer__close');

  if (hamburger && drawer) {
    const drawerPanels = drawer.querySelectorAll('.mobile-drawer__panel');
    const drawerTitle = drawer.querySelector('.mobile-drawer__title');
    const drawerBack = drawer.querySelector('.mobile-drawer__back');

    // Drill-down: a sub-panel replaces the main list (Patagonia-style)
    const showPanel = (name, title) => {
      drawerPanels.forEach(p => p.classList.toggle('active', p.getAttribute('data-panel') === name));
      if (drawerBack) drawerBack.hidden = name === 'main';
      // No title on the root panel; submenus set their own.
      if (drawerTitle) drawerTitle.textContent = title || '';
    };

    const setDrawer = (open) => {
      hamburger.classList.toggle('active', open);
      drawer.classList.toggle('active', open);
      if (drawerOverlay) drawerOverlay.classList.toggle('active', open);
      document.body.style.overflow = open ? 'hidden' : '';
      if (!open) showPanel('main');
    };

    hamburger.addEventListener('click', () => setDrawer(!drawer.classList.contains('active')));
    if (drawerClose) drawerClose.addEventListener('click', () => setDrawer(false));
    if (drawerOverlay) drawerOverlay.addEventListener('click', () => setDrawer(false));
    if (drawerBack) drawerBack.addEventListener('click', () => showPanel('main'));

    drawer.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-submenu]');
      if (trigger) showPanel(trigger.getAttribute('data-submenu'), trigger.getAttribute('data-title'));
    });

    // Close drawer on Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('active')) setDrawer(false);
    });
  }

  /* ---- Desktop Dropdowns ---- */
  document.querySelectorAll('.nav-dropdown').forEach(dropdown => {
    const trigger = dropdown.querySelector('.nav-dropdown__trigger');
    if (!trigger) return;

    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      // Close other dropdowns
      document.querySelectorAll('.nav-dropdown.active').forEach(d => {
        if (d !== dropdown) d.classList.remove('active');
      });

      dropdown.classList.toggle('active');
    });
  });

  // Close dropdowns on outside click
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.nav-dropdown')) {
      document.querySelectorAll('.nav-dropdown.active').forEach(d => {
        d.classList.remove('active');
      });
    }
  });

  /* ---- Product Gallery Carousel (mobile) ---- */
  const productGallery = document.querySelector('.product-page__gallery');
  const galleryDotsWrap = document.querySelector('.product-page__gallery-dots');
  const galleryDots = document.querySelectorAll('.product-page__gallery-dot');

  if (productGallery && galleryDotsWrap && galleryDots.length > 1) {
    // Dots are server-rendered hidden — only reveal them once they work
    galleryDotsWrap.removeAttribute('hidden');

    const setActiveDot = (index) => {
      galleryDots.forEach((dot, i) => {
        dot.classList.toggle('active', i === index);
        if (i === index) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    };

    let ticking = false;
    productGallery.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const index = Math.round(productGallery.scrollLeft / productGallery.clientWidth);
        setActiveDot(Math.max(0, Math.min(index, galleryDots.length - 1)));
        ticking = false;
      });
    }, { passive: true });

    galleryDots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        const slide = productGallery.children[index];
        const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        productGallery.scrollTo({
          left: slide ? slide.offsetLeft : index * productGallery.clientWidth,
          behavior: smooth ? 'smooth' : 'auto'
        });
      });
    });
  }

  /* ---- Product Image Lightbox ---- */
  const lightbox = document.getElementById('Lightbox');
  const galleryImgs = Array.from(document.querySelectorAll('.product-page__gallery-item img'));

  if (lightbox && galleryImgs.length) {
    const track = lightbox.querySelector('[data-lightbox-track]');
    const slides = Array.from(lightbox.querySelectorAll('[data-lightbox-slide]'));
    const thumbs = Array.from(lightbox.querySelectorAll('[data-lightbox-thumb]'));
    const counter = lightbox.querySelector('.lightbox__counter');
    const ZOOM = 2.5;
    let current = 0;
    let zoom = { scale: 1, x: 0, y: 0 };
    let lastFocus = null;

    const currentImg = () => slides[current].querySelector('img');
    const frame = lightbox.querySelector('.lightbox__frame');

    // Put the arrows on the photo itself: the image box is the whole slide, but a
    // portrait photo only fills its middle (object-fit: contain).
    const placeNav = () => {
      const img = currentImg();
      if (!img || !img.naturalWidth) return;
      const boxW = img.clientWidth;
      const boxH = img.clientHeight;
      const shownW = Math.min(boxW, boxH * (img.naturalWidth / img.naturalHeight));
      const inset = Math.max(0, (boxW - shownW) / 2) + 16;
      frame.style.setProperty('--lightbox-nav-left', inset + 'px');
      frame.style.setProperty('--lightbox-nav-right', inset + 'px');
    };
    slides.forEach((slide) => {
      slide.querySelector('img').addEventListener('load', () => {
        if (slides[current] === slide) placeNav();
      });
    });

    const applyZoom = () => {
      const img = currentImg();
      img.style.transform = zoom.scale === 1 ? '' : 'translate(' + zoom.x + 'px, ' + zoom.y + 'px) scale(' + zoom.scale + ')';
      lightbox.classList.toggle('is-zoomed', zoom.scale > 1);
    };

    // Keep the zoomed image covering its slide: no panning past its edges.
    const clampZoom = () => {
      const slide = slides[current];
      const maxX = (slide.clientWidth * (zoom.scale - 1)) / 2;
      const maxY = (slide.clientHeight * (zoom.scale - 1)) / 2;
      zoom.x = Math.max(-maxX, Math.min(maxX, zoom.x));
      zoom.y = Math.max(-maxY, Math.min(maxY, zoom.y));
    };

    const resetZoom = () => {
      if (zoom.scale === 1) return;
      zoom = { scale: 1, x: 0, y: 0 };
      slides.forEach((slide) => { slide.querySelector('img').style.transform = ''; });
      lightbox.classList.remove('is-zoomed');
    };

    // Zoom in around the tapped point, or back out.
    const toggleZoom = (clientX, clientY) => {
      if (zoom.scale > 1) { resetZoom(); return; }
      const rect = slides[current].getBoundingClientRect();
      const px = clientX - (rect.left + rect.width / 2);
      const py = clientY - (rect.top + rect.height / 2);
      zoom = { scale: ZOOM, x: -px * (ZOOM - 1), y: -py * (ZOOM - 1) };
      clampZoom();
      applyZoom();
    };

    const setCurrent = (index) => {
      if (index === current) return;
      resetZoom();
      current = index;
      placeNav();
      counter.textContent = (current + 1) + ' / ' + slides.length;
      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === current);
        if (i === current) {
          thumb.setAttribute('aria-current', 'true');
          thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
    };

    // Thumbnails, arrows and keys jump straight to the photo, with no slide animation.
    const goTo = (index, smooth) => {
      const target = (index + slides.length) % slides.length;
      resetZoom();
      track.scrollTo({ left: target * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
      setCurrent(target);
    };

    const openLightbox = (index) => {
      lastFocus = document.activeElement;
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
      current = -1;
      goTo(index, false);
      lightbox.focus({ preventScroll: true });
    };

    const closeLightbox = () => {
      resetZoom();
      lightbox.hidden = true;
      document.body.style.overflow = '';
      if (lastFocus) lastFocus.focus({ preventScroll: true });
    };

    galleryImgs.forEach((img, index) => {
      img.addEventListener('click', () => openLightbox(index));
    });

    // Swiping (or a trackpad) moves the track: follow it.
    let scrollTick = false;
    track.addEventListener('scroll', () => {
      if (scrollTick) return;
      scrollTick = true;
      requestAnimationFrame(() => {
        scrollTick = false;
        const index = Math.round(track.scrollLeft / track.clientWidth);
        setCurrent(Math.max(0, Math.min(index, slides.length - 1)));
      });
    }, { passive: true });

    lightbox.addEventListener('click', (e) => {
      if (e.target.closest('[data-lightbox-prev]')) { goTo(current - 1, false); return; }
      if (e.target.closest('[data-lightbox-next]')) { goTo(current + 1, false); return; }
      const thumb = e.target.closest('[data-lightbox-thumb]');
      if (thumb) { goTo(parseInt(thumb.getAttribute('data-lightbox-thumb'), 10), false); return; }
      if (e.target.closest('[data-lightbox-close]')) { closeLightbox(); return; }
      // A click on the dark area around the photo closes, unless zoomed in.
      if (zoom.scale === 1 && !e.target.closest('.lightbox__img, .lightbox__thumbs')) closeLightbox();
    });

    document.addEventListener('keydown', (e) => {
      if (lightbox.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); closeLightbox(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1, false); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1, false); }
    });

    // Desktop: double-click zooms.
    track.addEventListener('dblclick', (e) => {
      if (!e.target.closest('.lightbox__img')) return;
      e.preventDefault();
      toggleZoom(e.clientX, e.clientY);
    });

    // Touch: double-tap zooms (the page's own double-tap zoom is switched off in CSS).
    let lastTap = { time: 0, x: 0, y: 0 };
    let pan = null;

    track.addEventListener('pointerdown', (e) => {
      if (zoom.scale > 1 && e.target.closest('.lightbox__img')) {
        pan = { id: e.pointerId, startX: e.clientX, startY: e.clientY, x: zoom.x, y: zoom.y, moved: false };
        e.target.setPointerCapture(e.pointerId);
      }
    });

    track.addEventListener('pointermove', (e) => {
      if (!pan || e.pointerId !== pan.id) return;
      const dx = e.clientX - pan.startX;
      const dy = e.clientY - pan.startY;
      if (Math.abs(dx) + Math.abs(dy) > 4) pan.moved = true;
      zoom.x = pan.x + dx;
      zoom.y = pan.y + dy;
      clampZoom();
      applyZoom();
    });

    const endPan = (e) => {
      const wasPan = pan && pan.moved;
      if (pan && e.pointerId === pan.id) pan = null;
      if (e.pointerType !== 'touch' || wasPan || !e.target.closest('.lightbox__img')) return;
      const now = Date.now();
      const close = Math.abs(e.clientX - lastTap.x) < 30 && Math.abs(e.clientY - lastTap.y) < 30;
      if (now - lastTap.time < 300 && close) {
        toggleZoom(e.clientX, e.clientY);
        lastTap = { time: 0, x: 0, y: 0 };
      } else {
        lastTap = { time: now, x: e.clientX, y: e.clientY };
      }
    };
    track.addEventListener('pointerup', endPan);
    track.addEventListener('pointercancel', (e) => { if (pan && e.pointerId === pan.id) pan = null; });

    // A resize changes the slide width: stay on the same image.
    window.addEventListener('resize', () => {
      if (lightbox.hidden) return;
      resetZoom();
      track.scrollTo({ left: current * track.clientWidth, behavior: 'auto' });
      placeNav();
    });
  }

  /* ---- Search panel (header drop-down with live suggestions) ---- */
  const searchPanel = document.getElementById('SearchPanel');

  if (searchPanel) {
    const searchInput = document.getElementById('SearchPanelInput');
    const searchResults = document.getElementById('SearchPanelResults');
    let debounce = null;
    let inflight = null;

    const openSearch = () => {
      // iOS only raises the keyboard when focus() runs inside the tap's own call
      // stack. Reveal the panel and focus synchronously; the slide-in class can
      // wait for the next frame, since a class change does not affect focus.
      searchPanel.hidden = false;
      if (searchInput) searchInput.focus({ preventScroll: true });
      window.requestAnimationFrame(() => {
        searchPanel.classList.add('is-open');
      });
    };

    const closeSearch = () => {
      searchPanel.classList.remove('is-open');
      window.setTimeout(() => { searchPanel.hidden = true; }, 250);
    };

    const suggest = (terms) => {
      // Under two characters the panel is just the bar, nothing below it.
      if (terms.length < 2) {
        if (searchResults) searchResults.innerHTML = '';
        return;
      }

      // Drop the previous request so slow answers cannot overwrite newer ones.
      if (inflight) inflight.abort();
      inflight = new AbortController();

      const url = '/search/suggest'
        + '?q=' + encodeURIComponent(terms)
        + '&section_id=predictive-search'
        + '&resources%5Btype%5D=product'
        + '&resources%5Blimit%5D=6';

      fetch(url, { signal: inflight.signal })
        .then(r => r.text())
        .then(html => {
          const fresh = new DOMParser().parseFromString(html, 'text/html')
            .getElementById('PredictiveSearchResults');
          if (searchResults) searchResults.innerHTML = fresh ? fresh.innerHTML : '';
        })
        .catch(() => {});
    };

    // The trigger stays a real link to the search page for no-JS visitors.
    document.addEventListener('click', (e) => {
      const opener = e.target.closest('#nav-search, [data-search-open]');
      if (opener) {
        e.preventDefault();
        openSearch();
        return;
      }
      if (e.target.closest('[data-search-close]')) {
        closeSearch();
        return;
      }
      // Clicking off the panel closes it, but not a click on the header itself.
      if (!searchPanel.hidden
        && !searchPanel.contains(e.target)
        && !e.target.closest('.site-header__inner')) {
        closeSearch();
      }
    });

    if (searchInput) {
      searchInput.addEventListener('input', () => {
        window.clearTimeout(debounce);
        const terms = searchInput.value.trim();
        debounce = window.setTimeout(() => suggest(terms), 250);
      });
    }

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !searchPanel.hidden) closeSearch();
    });
  }

  /* ---- Cart Drawer (slide-over, no page redirect) ---- */
  const cartDrawer = document.getElementById('CartDrawer');
  const cartOverlay = document.getElementById('CartDrawerOverlay');

  if (cartDrawer && cartOverlay) {
    const updateCartCounts = () => {
      const countEl = cartDrawer.querySelector('[data-cart-count]');
      if (!countEl) return;
      const n = countEl.textContent.trim();
      document.querySelectorAll('.cart-count').forEach(el => { el.textContent = '(' + n + ')'; });
      document.querySelectorAll('.cart-badge').forEach(el => {
        el.textContent = n;
        if (n === '0') { el.setAttribute('hidden', ''); } else { el.removeAttribute('hidden'); }
      });
    };

    const openCart = () => {
      cartDrawer.classList.add('is-open');
      cartOverlay.classList.add('is-open');
      cartDrawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    };

    const closeCart = () => {
      cartDrawer.classList.remove('is-open');
      cartOverlay.classList.remove('is-open');
      cartDrawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };

    // Swap the drawer content with a freshly rendered version (Section Rendering API)
    const swapCartHtml = (html) => {
      const fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('CartDrawer');
      if (fresh) {
        cartDrawer.innerHTML = fresh.innerHTML;
        updateCartCounts();
      }
    };

    const refreshCart = () =>
      fetch(window.location.pathname + '?sections=cart-drawer')
        .then(r => r.json())
        .then(data => { if (data['cart-drawer']) swapCartHtml(data['cart-drawer']); })
        .catch(() => {});

    // Archive pieces are one of a kind. Once a piece sits in the cart its Add to
    // Cart button locks; removing it from the drawer unlocks the button again,
    // with no page reload. Takes a cart object, as returned by /cart/change.js.
    const syncAddButtons = (cartData) => {
      const items = (cartData && cartData.items) || [];
      document.querySelectorAll('[data-max-quantity]').forEach(btn => {
        const max = parseInt(btn.getAttribute('data-max-quantity'), 10);
        if (!max) return;
        const form = btn.closest('form');
        const idField = form && form.querySelector('[name="id"]');
        if (!idField) return;
        const variantId = String(idField.value);
        let qty = 0;
        items.forEach(it => { if (String(it.variant_id) === variantId) qty = it.quantity; });
        const atMax = qty >= max;
        btn.disabled = atMax;
        btn.textContent = atMax
          ? (btn.getAttribute('data-in-cart-label') || 'Already in cart')
          : (btn.getAttribute('data-add-label') || 'Add to Cart');
      });
    };

    // Open from any cart link (header icon, desktop nav, etc.) — no navigation
    document.addEventListener('click', (e) => {
      const opener = e.target.closest('a[href="/cart"], a[href^="/cart?"], [data-cart-open]');
      if (opener) {
        e.preventDefault();
        openCart();
        return;
      }

      if (e.target.closest('[data-cart-close]')) {
        closeCart();
        return;
      }

      // Quantity +/- and Remove (event delegation — content is swapped after updates)
      const qtyBtn = e.target.closest('[data-qty-change], [data-qty-set]');
      if (qtyBtn && cartDrawer.contains(qtyBtn)) {
        let line, quantity;
        if (qtyBtn.hasAttribute('data-qty-set')) {
          line = parseInt(qtyBtn.getAttribute('data-line'), 10);
          quantity = parseInt(qtyBtn.getAttribute('data-qty-set'), 10);
        } else {
          const wrap = qtyBtn.closest('.cart-item__qty');
          line = parseInt(wrap.getAttribute('data-line'), 10);
          quantity = Math.max(0, parseInt(wrap.getAttribute('data-quantity'), 10) + parseInt(qtyBtn.getAttribute('data-qty-change'), 10));
        }
        qtyBtn.disabled = true;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: quantity, sections: 'cart-drawer' })
        })
          .then(r => r.json())
          .then(data => {
            syncAddButtons(data);
            if (data.sections && data.sections['cart-drawer']) {
              swapCartHtml(data.sections['cart-drawer']);
            } else {
              return refreshCart();
            }
          })
          .catch(() => refreshCart())
          .finally(() => { qtyBtn.disabled = false; });
      }
    });

    cartOverlay.addEventListener('click', closeCart);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && cartDrawer.classList.contains('is-open')) closeCart();
    });

    // AJAX add-to-cart: open the drawer instead of navigating to the cart page
    document.querySelectorAll('form[action="/cart/add"], form[action^="/cart/add?"]').forEach(form => {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) submitBtn.disabled = true;

        const formData = new FormData(form);
        formData.append('sections', 'cart-drawer');

        // A capped product stays locked after a successful add, so the shopper
        // cannot push a one-of-a-kind piece to quantity two.
        let stayLocked = false;

        fetch('/cart/add.js', { method: 'POST', body: formData })
          .then(r => r.json().then(json => ({ ok: r.ok, json: json })))
          .then(res => {
            if (!res.ok) throw new Error(res.json.description || res.json.message || 'Could not add to cart');
            if (submitBtn && parseInt(submitBtn.getAttribute('data-max-quantity'), 10) > 0) {
              stayLocked = true;
              submitBtn.textContent = submitBtn.getAttribute('data-in-cart-label') || 'Already in cart';
            }
            if (res.json.sections && res.json.sections['cart-drawer']) {
              swapCartHtml(res.json.sections['cart-drawer']);
              openCart();
            } else {
              return refreshCart().then(openCart);
            }
          })
          .catch(err => { window.alert(err.message); })
          .finally(() => { if (submitBtn && !stayLocked) submitBtn.disabled = false; });
      });
    });
  }

  /* ---- Scroll Animations ---- */
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    document.querySelectorAll('.animate-on-scroll').forEach(el => {
      el.style.opacity = '0';
      observer.observe(el);
    });
  }

})();
